import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { AdvancedSearchGenres } from "./AdvancedSearchGenres";
import { AdvancedSearchReadingLists } from "./AdvancedSearchReadingLists";
import { AdvancedSearchReadingLevels } from "./AdvancedSearchReadingLevels";
import { AdvancedSearchFormats } from "./AdvancedSearchFormats";

/**
 * Renderiza la sección seleccionada de la búsqueda avanzada en dispositivos móviles.
 *
 * Muestra un encabezado con la opción para regresar al menú principal y renderiza
 * dinámicamente el componente correspondiente a la categoría seleccionada
 * (géneros, listas, niveles o formatos).
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.section - Identificador de la sección activa.
 * @param {Object} props.textos - Objeto con los textos e internacionalización de la interfaz.
 * @param {Object} props.data - Datos utilizados para construir las opciones de búsqueda.
 * @param {Function} props.onBack - Función que regresa al menú principal.
 * @param {Function} [props.onClose] - Función opcional que cierra el menú de búsqueda avanzada.
 * @returns {JSX.Element} AdvancedSearchMobileSection
 */
export const AdvancedSearchMobileSection = ({
    section,
    textos,
    data,
    onBack,
    onClose,
}) => {

    const sections = {
        generos: AdvancedSearchGenres,
        listas: AdvancedSearchReadingLists,
        niveles: AdvancedSearchReadingLevels,
        formato: AdvancedSearchFormats,
    };

    const SectionComponent = sections[section];

    return (
        <section
            className="advanced-search-mobile-section"
            onClick={(event) => event.stopPropagation()}
        >

            <header className="advanced-search-mobile-section-header">
                <button
                    type="button"
                    onClick={(event) => {
                        event.stopPropagation();
                        onBack();
                    }}
                    aria-label="Volver"
                >
                    <Icon
                        icon="material-symbols:arrow-back"
                        width={24}
                    />
                    <span className="ml-3">
                        {textos?.content?.busqueda || "Búsqueda"}
                    </span>
                </button>


            </header>

            {SectionComponent && (
                <SectionComponent
                    textos={textos}
                    data={data}
                    isMobile
                    onClose={onClose}
                />
            )}
        </section>
    );
};